import React, { useEffect } from 'react';
import { useGame } from '../context/GameContext.jsx';
import Card from './Card.jsx';

const MissionScreen = () => {
  const {
    currentCards,
    translations,
    lang
  } = useGame();

  const missionCard = currentCards.find(card => card.Type && card.Type.toLowerCase() === "mission");

  if (!missionCard) {
    return (
      <div className="text-center mt-5">
        <div className="spinner-border text-light" role="status">
          <span className="visually-hidden">{translations[lang]?.loading_text}</span>
        </div>
        <p className="text-light mt-3">{translations[lang]?.loading_mission_text}</p>
      </div>
    );
  }

  return (
    <div className="mission-screen-content d-flex flex-column align-items-center">
      {missionCard ? (
        <Card card={missionCard} isMissionCard={true} />
      ) : (
        <p className="text-light">{translations[lang]?.loading_text}</p>
      )}
    </div>
  );
};

export default MissionScreen;
